/**
 * @generated SignedSource<<354ee8af8fe393e94c341b24ba26b373>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum PublicLinkPermissionsObjectType {
  CONTENT = "CONTENT",
}
export enum PublicLinkPermissionsType {
  EDIT = "EDIT",
}
export interface RemovePublicLinkPermissionsInput {
  objectId: Scalars["ID"]["input"];
  objectType: PublicLinkPermissionsObjectType;
  permissions: Array<PublicLinkPermissionsType>;
}
export type useRemovePublicLinkPermissionsMutationRemovePublicLinkPermissionsMutation_removePublicLinkPermissions_RemovePublicLinkPermissionsPayload_errors_MutationError =
  {
    __typename?: "MutationError";
    message: string | null;
  };
export type useRemovePublicLinkPermissionsMutationRemovePublicLinkPermissionsMutation_removePublicLinkPermissions_RemovePublicLinkPermissionsPayload =
  {
    __typename?: "RemovePublicLinkPermissionsPayload";
    success: boolean;
    errors: Array<useRemovePublicLinkPermissionsMutationRemovePublicLinkPermissionsMutation_removePublicLinkPermissions_RemovePublicLinkPermissionsPayload_errors_MutationError> | null;
  };
export type useRemovePublicLinkPermissionsMutationRemovePublicLinkPermissionsMutation_Mutation =
  {
    __typename?: "Mutation";
    removePublicLinkPermissions: useRemovePublicLinkPermissionsMutationRemovePublicLinkPermissionsMutation_removePublicLinkPermissions_RemovePublicLinkPermissionsPayload;
  };
export type useRemovePublicLinkPermissionsMutationRemovePublicLinkPermissionsMutationVariables =
  Exact<{
    removePublicLinkPermissionsInput: RemovePublicLinkPermissionsInput;
  }>;
export type useRemovePublicLinkPermissionsMutationRemovePublicLinkPermissionsMutation =
  useRemovePublicLinkPermissionsMutationRemovePublicLinkPermissionsMutation_Mutation;
